// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"940a8f05","251":"89cb5752","334":"bd72e6bf","348":"86c9bafd","571":"1d08acf3"}[chunkId] + ".chunk.js";
};